export type ToastOptions = { duration?: number; position?: 'top' | 'bottom' | 'center' } & Record<string, any>;

type ToastImpl = {
  showSuccess: (message: string, options?: Partial<ToastOptions>) => void;
  showError: (message: string, options?: Partial<ToastOptions>) => void;
  showInfo?: (message: string, options?: Partial<ToastOptions>) => void;
  showWarning?: (message: string, options?: Partial<ToastOptions>) => void;
};

let impl: ToastImpl | null = null;

export const registerToastImpl = (i: ToastImpl) => {
  impl = i;
};

export const unregisterToastImpl = () => {
  impl = null;
};

export const showSuccess = (message: string, options?: Partial<ToastOptions>) => {
  if (impl && impl.showSuccess) return impl.showSuccess(message, options as any);
  if (typeof window !== 'undefined' && (window as any).alert) return (window as any).alert(message);
  // no-op if no fallback
};

export const showError = (message: string, options?: Partial<ToastOptions>) => {
  if (impl && impl.showError) return impl.showError(message, options as any);
  if (typeof window !== 'undefined' && (window as any).alert) return (window as any).alert(message);
};

export const showInfo = (message: string, options?: Partial<ToastOptions>) => {
  if (impl && impl.showInfo) return impl.showInfo(message, options as any);
  if (typeof window !== 'undefined' && (window as any).alert) return (window as any).alert(message);
};

export const showWarning = (message: string, options?: Partial<ToastOptions>) => {
  if (impl && impl.showWarning) return impl.showWarning(message, options as any);
  if (typeof window !== 'undefined' && (window as any).alert) return (window as any).alert(message);
};

export default {
  registerToastImpl,
  unregisterToastImpl,
  showSuccess,
  showError,
  showInfo,
  showWarning,
};
